import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { AnalysisProvider } from './context/AnalysisContext';
import App from './App';
import './index.css'; // print styles for Download Report (.printable-report / .no-print)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AnalysisProvider>
      <CssBaseline />
      <App />
    </AnalysisProvider>
  </React.StrictMode>
);
